
(function mobileDetectionModuleDefinition() {

    angular.module('MobileDetection', []);

})();